import _get from "lodash/get";
import track from "./track";
export default (function (state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  if (type === '@ReduxToastr/toastr/ADD') {
    var trackingState = _get(state, 'identity.tracking', null);

    var message = payload.title;
    track('message:shown', trackingState, {
      message: message
    });
  }
});